<div class="d-flex flex-column" style="padding: 0 15px ;" *ngIf="showPage">
  <div class="d-flex flex-wrap gap-3 event-tabs">
    <div class="events-type" [ngClass]="(currentSelectedEventsType && (currentSelectedEventsType === 'Upcoming Growth Events')) ? 'selected-event-type' : ''" (click)="selectEventType('Upcoming Growth Events')">Upcoming Growth Events</div>
    <div class="events-type" [ngClass]="(currentSelectedEventsType && (currentSelectedEventsType === 'Growth Plan Marketing Program')) ? 'selected-event-type' : ''" (click)="selectEventType('Growth Plan Marketing Program')">Growth Plan Marketing Program</div>
    <div class="events-type" [ngClass]="(currentSelectedEventsType && (currentSelectedEventsType === 'Step by Step Tax Planning Guides')) ? 'selected-event-type' : ''" (click)="selectEventType('Step by Step Tax Planning Guides')">Step by Step Tax Planning Guides</div>
  </div>
  <ng-template [ngIf]="currentSelectedEventsType === 'Upcoming Growth Events'">
  <div class="d-flex justify-content-end mt-2" style="padding: 5px;border: 1px solid #EAECF0;border-radius: 4px;">
    <div class="resources-options">
      <span class="pointer plan-button" (click)="createEvent()" *ngIf="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'"><i class="ion-plus-round pe-1"></i> Create Event</span>
      <!-- <span class="pointer plan-button" (click)="showAdditionalResources()"><img class="margin-right-5" src="../../../../images/growth-plan/eye.png"/> Additional Resources</span> -->
    </div>
  </div>
  <div class="d-inline-flex flex-column mt-1 position-relative" style="width: fit-content;" *ngIf="upcomingEvents && upcomingEvents.length > 0">
    <div class="d-flex justify-content-between">
      <!-- <div class="bold" style="font-size: 16px;">Upcoming Growth Events</div> -->
      <div class="navigation-icons d-flex justify-content-between align-items-center position-absolute">
        <button class="navigate-icon-left ms-0 bg-white" (click)="previous()" [disabled]="startIndex === 0">
          <i class="icon ion-chevron-left"></i>
        </button>
        <button  class="navigate-icon-right bg-white" (click)="next()"[disabled]="endIndex >= upcomingEvents.length">
          <i class="icon ion-chevron-right"></i>
        </button>
      </div>
    </div>

    <div class="d-flex justify-content-start gap-2 mt-2">
      <div class="upcoming-event-box d-flex flex-column" *ngFor="let event of visibleUsers"
           [ngStyle]="{'background-color': event.bgColor}">
        <div class="d-flex justify-content-between">
          <div class="mt-1 mb-1 bold" style="font-size: 16px">{{event.startDate}}</div>
          <ng-template [ngIf]="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'">
            <button mat-icon-button [matMenuTriggerFor]="beforeMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #beforeMenu="matMenu"  xPosition="before">
              <button mat-menu-item class="vendor-options" (click)="openEventForEdit(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/edit.png"/>Edit</button>
              <button mat-menu-item class="vendor-options" (click)="showEventInfo(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/eye.png"/>View</button>
              <button mat-menu-item class="vendor-options" (click)="deleteEvent(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/trash.png"/>Delete</button>
            </mat-menu>
          </ng-template>
        </div>
        <div class="pointer" (click)="showEventInfo(event)">
          <div class="mt-2 mb-1 bold event-name">{{event.name}}</div>
          <div class="mt-1 mb-2 event-description" style="font-size: 13px;">
            <div [innerHTML]="event.description"></div>
          </div>
          <div class="d-flex justify-content-between location-time">
            <div *ngIf="event.location"><img class="growth-plan-icon" src="../../../../images/growth-plan/map-pin.png"/> {{event.location}}</div>
            <div class="text-nowrap" *ngIf="event.timeValue"><img class="growth-plan-icon" src="../../../../images/growth-plan/clock.png"/> {{event.timeValue}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column mt-3" [ngStyle]="{'height': (upcomingEvents && upcomingEvents.length > 0) ? 'calc(58vh - 60px)' : 'calc(88vh - 60px)'}">
    <div class="d-flex plan-box mb-3" style="margin-right: 8px;background-color: #EFF8FF" *ngIf="oneOnOneEvent">
      <div class="growth-event-logo" style="width: 10rem;" [ngStyle]="oneOnOneEvent.logoBg"></div>
      <div class="d-flex justify-content-between w-100">
        <div class="d-flex flex-column ps-3 pe-3" style="width: 80%">
          <div class="name mb-2 pointer event-name" (click)="editOneOnOne()">{{oneOnOneEvent.name}}</div>
          <div class="mb-2 event-description" style="color: #475467;font-size: 13px">
            <div [innerHTML]="oneOnOneEvent.description"></div>
          </div>
          <div class="d-flex text">
            <div><img class="growth-plan-icon" src="../../../../images/growth-plan/map-pin.png"/></div>
            <div>{{oneOnOneEvent.location}}</div>
          </div>
        </div>
        <div class="d-flex flex-column gap-3 align-items-center">
          <div class="text register-link float-right pointer schedule-one-on-one d-flex gap-1" (click)="oneOnOneSchedule(linkItem)" *ngFor="let linkItem of oneOnOneEvent.link">
            <div>{{linkItem.name}}</div>
            <div class="export-link"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column gap-3 flex-fill min-h-0 overflow-auto" style="padding-right: 8px;">
      <ng-container *ngFor="let event of normalEvents; let i = index">
      <div class="d-flex plan-box">
      <!-- <div class="d-flex plan-box"  *ngFor="let event of normalEvents"> -->
        <div class="growth-event-logo" style="width: 10rem" [ngStyle]="event.logoBg"></div>
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex flex-column ps-3 pe-3" style="width: 80%">
            <div class="name mb-2 pointer event-name"  (click)="showEventInfo(event)">{{event.name}}</div>
            <div class="d-flex justify-content-between text">
              <div class="d-flex" *ngIf="event.date">
                <div><img class="growth-plan-icon" src="../../../../images/growth-plan/calendar.png"/></div>
                <div>{{event.date}}</div>
              </div>
              <div class="d-flex" *ngIf="event.timeValue">
                <div><img class="growth-plan-icon" src="../../../../images/growth-plan/clock.png"/></div>
                <div>{{event.timeValue}}</div>
              </div>
              <div class="d-flex" *ngIf="event.location">
                <div><img class="growth-plan-icon" src="../../../../images/growth-plan/map-pin.png"/></div>
                <div>{{event.location}}</div>
              </div>
            </div>
          </div>
          <div>
          <span class="pointer float-right" *ngIf="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'">
            <button mat-icon-button [matMenuTriggerFor]="beforeMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #beforeMenu="matMenu"  xPosition="before">
              <button mat-menu-item class="vendor-options" (click)="openEventForEdit(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/edit.png"/>Edit</button>
              <button mat-menu-item class="vendor-options" (click)="showEventInfo(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/eye.png"/>View</button>
              <button mat-menu-item class="vendor-options" (click)="deleteEvent(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/trash.png"/>Delete</button>
            </mat-menu>
          </span>
            <span *ngIf="event.link" class="text register-link float-right pointer" (click)="eventRegisterLink(event)">Register Here <img class="growth-plan-icon ps-1" src="../../../../images/core-focus/external-link.png"/></span>
          </div>
        </div>
      </div>
      <div *ngIf="event.pinned && !normalEvents[i + 1]?.pinned" class="mb-3">
        <hr class="mw-100 w-100" />
      </div>
    </ng-container>
    </div>
  </div>
  </ng-template>
</div>



<ng-template [ngIf]="currentSelectedEventsType === 'Growth Plan Marketing Program'">
  <div style="padding: 0 15px;">
    <div class="mb-3 text-right d-block mt-2" *ngIf="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'" style="padding: 5px;border: 1px solid #EAECF0;border-radius: 4px;">
      <span class="pointer upload-resource" (click)="uploadTemplate()"><i class="ion-plus-round pe-2"></i>Upload Template</span>
    </div>
  </div>
  <div class="d-flex additional-resources mb-3 justify-content-between gap-3 static-content-wrapper mb-2 mt-1">
    <img class="thumbnail-img" src="../../../../images/growth-plan/how_to_guide.png" alt="how_to_guide"/>

    <div class="heading d-flex flex-column flex-grow-1 gap-2">
      <div class="resource-name mw-100">How-To Guide for Email Marketing</div>
      <p>How to setup and send strategic emails for your tax firm.</p>
    </div>

    <div class="d-flex flex-column gap-3 align-items-end">
      <div class="d-flex justify-content-between gap-2 list-tags mt-1 mb-1 align-items-center"> 
        <img class="file-icon mb-0" src="../../../../images/pdf-icon.svg" alt="pdfIcon"/>
        <div class="file-name resource-file-name m-0 text-truncate">How To Guide for Email Marketing Tax Advisors</div>
        <div aria-label="Download How-To Guide for Email Marketing for Tax Advisors" download class="pointer text-decoration-none mb-0">
          <img class="download-icon" (click)="getFileData({id:staticFileId})" src="../../../images/tpiq-icons/download_icon.png"/>
      </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-wrap gap-3 event-tabs" style="padding: 15px 15px 0;">
    <div class="events-type" [ngClass]="(currentSelectedEventsType && (selectedGrowthPlanMarketingType === 'Prospects')) ? 'selected-event-type' : ''" (click)="selectGrowthPlanMarketingType('Prospects')">Prospects</div>
    <div class="events-type" [ngClass]="(currentSelectedEventsType && (selectedGrowthPlanMarketingType === 'Clients')) ? 'selected-event-type' : ''" (click)="selectGrowthPlanMarketingType('Clients')">Clients</div>
  </div>
  <div style="padding: 0 15px 0;">
    <hr class="mw-100 w-100"/>
  </div>
   <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 growth-plan-wrapper" style="padding: 0 15px 15px;">
   <div *ngFor="let item of emailTemplateList" class= "w-100 d-flex flex-column gap-3 justify-content-between mb-4">
      <div class="resource-name fw-bold d-flex align-items-center gap-2"> 
        <img [src]="'../../../../images/growth-category-icons/' + formatCategoryName(item.categoryName) + '.png'" (error)="onGrowthCategoryImageError($event)" alt="{{ item.categoryName }}" /> 
        {{ item.categoryName }}
      </div>
      <div class="plan-box d-flex flex-column gap-2 flex-grow-1 w-100">
        <ul class="d-flex flex-wrap gap-3 w-100">
          <li *ngFor="let template of item.templates" class="w-100 d-flex justify-content-between gap-3 border-bottom align-items-center">
            <h6 class=""> {{ template.templateName }} </h6>   
            <!-- <div class="file-name">{{template.docLocation[0].name}}</div> -->
            <!-- <a *ngIf="template.docLocation" [href]="template.docLocation[0].link" target="_blank">View </a>  -->
            <div class="d-flex justify-content-between list-tags mt-1 mb-1 align-items-center">    
               <img class="file-icon" src="../../../../images/DOCX.png" alt="docicon"/>          
              <div class="file-name resource-file-name m-0 text-truncate">{{template.docLocation[0].name}}</div>
              <div class="d-flex gap-2 align-items-center active-icons">
                <div class="pointer">
                  <img class="download-icon" (click)="getFileData(template.docLocation[0])" src="../../../images/tpiq-icons/download_icon.png"/>
                </div>
                <ng-template [ngIf]="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'">
                  <div class="pointer" (click)="deleteTemplate(template)"><i class="material-icons resource-delete">delete</i></div>
                </ng-template>
              </div>
          </div>
          </li>
        </ul>
      </div>      
    </div>
    </div>
  

 

  <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 growth-plan-wrapper" style="padding: 0 15px 15px;">
    <div *ngIf="revealTemplate['additionalTemplate']">
      <div class="reveal-overlay" [ngClass]="{'qount-reveal': revealTemplate['additionalTemplate']}">
      </div>
      <div class="reveal tax-strategy-reveal new-tpiq-reveal" style="padding: 0; border: none;" [ngClass]="{'qount-reveal': revealTemplate['additionalTemplate']}">
        <div class="reveal-header">
          <span class="float-left">Additional Template</span>
          <span class="float-right pointer" (click)="hideReveal('additionalTemplate')">X</span>
        </div>
        <div style="padding: 0 15px;">
          <hr style="margin: 0;"/>
        </div>
        <div class="body reveal-publish new-input-fields d-flex flex-column flex-fill min-h-0 overflow-auto" style="padding: 15px;height: calc(100vh - 60px)">
          <ng-template [ngIf]="createTemplates">
            <div class="d-flex flex-column resource-edit-section">
              <div >
                <label>Audience<span class="text-danger">*</span></label>
                <select [(ngModel)]="template.audience" class="form-control">
                  <option [ngValue]="null">-- Select Audience --</option>
                  <option value="prospects">Prospects</option>
                  <option value="clients">Clients</option>
                </select>
              </div>
              <div >
                <label>Category<span class="text-danger">*</span></label>
                <select [(ngModel)]="template.categoryId" class="form-control">
                  <option [ngValue]="null">-- Select Category --</option>
                  <option *ngFor="let category of categoryList" [value]="category.categoryId">
                    {{ category.categoryName }}
                  </option>
                </select>
              </div>
              <div>
                <label>Template Title<span class="text-danger">*</span>
                  <input type="text" placeholder="Enter template title here..." [(ngModel)]="template.templateName"/>
                </label>
              </div>
              <div class="mt-2">
                <label>Template File<span class="text-danger">*</span></label>
                <section class="upload-area create-post"
                ng2FileDrop
                [uploader]="templateUploader"
                (onFileDrop)="fileDropOver($event, 'template')"
                (fileOver)="fileOverBase($event, 'template')">
          <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasBaseDropZoneOver}">
            <div class="columns medium-12 text-center">
              <span class="pointer">
                <img src="../../../images/tpiq-icons/upload-cloud.png" />
                <label for="templateUpload" class="button upload-section-content">Upload File(s)</label>
              </span>
              <input type="file"
                    id="templateUpload"
                    (change)="fileDropOver($event, 'template')"
                    class="show-for-sr"
                    ng2FileSelect
                    [uploader]="templateUploader" />
            </div>
          </div>
        </section>
      </div>
              <div class="mt-3" *ngIf="template.files && template.files.length > 0">
                <div class="d-flex flex-wrap">
                  <div class="uploaded-file-box d-flex justify-content-between mb-2"  *ngFor="let file of template.files; let i=index;">
                    <div *ngIf="file.fileType === 'pdf'"><img src="../../../images/tpiq-icons/pdf-icon.png"/></div>
                    <div *ngIf="file.fileType === 'excel'"><img src="../../../images/tpiq-icons/excel-icon.png"/></div>
                    <div *ngIf="file.fileType === 'image'">
                      <i class="icon ion-image"></i>
                    </div>
                    <div *ngIf="file.fileType === 'video'">
                      <i class="icon ion-ios-videocam"></i>
                    </div>
                    <div class="file-name">{{file.name}}</div>
                    <div class="pointer" (click)="deleteDocumentFile(file, i, 'template')">
                      <i class="icon ion-android-close"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <button class="button small float-right resource-button" (click)="saveGrowthPlanEmailTemplate()">Create</button>
              <button class="button small float-right cancel-button resource-button" (click)="toggleCreateTemplate()">Cancel</button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
</div>

</ng-template>



<ng-template [ngIf]="currentSelectedEventsType === 'Step by Step Tax Planning Guides'" >
    <div style="padding: 0 15px;">
      <div class="mb-3 text-right d-block mt-2" *ngIf="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'" style="padding: 5px;border: 1px solid #EAECF0;border-radius: 4px;">
        <span class="pointer upload-resource" (click)="uploadResource()"><i class="ion-plus-round pe-2"></i>Upload Resource</span>
      </div>
    </div>  
    <div class="d-flex flex-column w-100" style="padding: 0 15px;">
      <ng-template [ngIf]="additionalResources && additionalResources.length > 0">
        <ng-container *ngFor="let resource of additionalResources; let i = index">
        <div class="d-flex additional-resources mb-3 justify-content-between gap-3">
          <div class="d-flex gap-3 align-items-start flex-grow-1">
            <div class="resource-logo" [ngStyle]="resource.logoBg"></div>
            <!-- <div class="d-flex gap-3 flex-grow-1"> -->
              <div class="heading d-flex flex-column flex-grow-1">
                <div class="resource-name mw-100">{{resource.name}}</div>
                <div class="text mt-0 resource-description" *ngIf="resource.description">
                  <app-tpiq-froala-view [data]="resource.description"></app-tpiq-froala-view>
                </div>
              </div>

              <div class="d-flex flex-column gap-3 align-items-end"> 
                <div class="active-icons d-flex gap-1">
                  <ng-template [ngIf]="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'">
                    <div class="pointer" (click)="editResource(resource)"><i class="material-icons resource-edit">mode_edit</i></div>
                    <div class="pointer" (click)="deleteResource(resource)"><i class="material-icons resource-delete">delete</i></div>
                  </ng-template>
                </div>

                <div *ngIf="resource.files && resource.files.length > 0">
                  <div class="d-flex flex-wrap justify-content-end">
                    <div class="uploaded-file-box d-flex justify-content-between mb-2 w-100"  *ngFor="let file of resource.files; let i=index;">
                      <div *ngIf="file.fileType === 'pdf'">
                        <img class="file-icon" src="../../../images/tpiq-icons/pdf-icon.png"/>                        
                      </div>
                      <div *ngIf="file.fileType === 'excel'"><img src="../../../images/tpiq-icons/excel-icon.png"/></div>
                      <div *ngIf="file.fileType === 'image'">
                        <i class="icon ion-image" style="margin: 0"></i>
                      </div>
                      <div *ngIf="file.fileType === 'video'">
                        <i class="icon ion-ios-videocam"></i>
                      </div>
                      <div class="file-name resource-file-name">{{file.name}}</div>
                      <div class="pointer">
                        <img class="download-icon" (click)="getFileData(file)" src="../../../images/tpiq-icons/download_icon.png"/>
                      </div>
                    </div>
                  </div>
                </div>          
              </div>        
            <!-- </div> -->
          </div>
        </div>
        <div *ngIf="resource.pinned && !additionalResources[i + 1]?.pinned" class="mb-3">
          <hr class="mw-100 w-100" />
        </div>
        </ng-container>
      </ng-template>
      <ng-template [ngIf]="additionalResources && additionalResources.length == 0">
        <div class="no-content-box">
          <div class="no-data-container d-flex align-items-center justify-content-center">
            No resources data available.
          </div>
        </div>
      </ng-template>
    </div>

    <div *ngIf="reveal['additionalResources']" style="padding: 0 15px;">
      <div class="reveal-overlay" [ngClass]="{'qount-reveal': reveal['additionalResources']}">
      </div>
      <div class="reveal tax-strategy-reveal new-tpiq-reveal" style="padding: 0; border: none;" [ngClass]="{'qount-reveal': reveal['additionalResources']}">
        <div class="reveal-header">
          <span class="float-left">Additional Resources</span>
          <span class="float-right pointer" (click)="hideReveal('additionalResources')">X</span>
        </div>
        <div style="padding: 0 15px;">
          <hr style="margin: 0;"/>
        </div>
        <div class="body reveal-publish new-input-fields d-flex flex-column flex-fill min-h-0 overflow-auto" style="padding: 15px;height: calc(100vh - 60px)">
          <ng-template [ngIf]="createOrEditResource">
            <div class="d-flex flex-column resource-edit-section">
              <div>
                <label>Name
                  <input type="text" placeholder="Enter name here..." [(ngModel)]="resource.name"/>
                </label>
              </div>
              <div class="mb-3">
                <label>Description
                  <div class="padding-10" style="border:1px solid #cacaca;border-radius: 3px;" [froalaEditor]="editorOptions" [(froalaModel)]="resource.description"></div>
                </label>
              </div>
              <div class="mt-2 mb-3">
                <label>
                  Thumbnail
                  <section class="upload-area create-post" ng2FileDrop [uploader]="resourceImageUploader" (onFileDrop)="fileDropOver($event, 'image')" (fileOver)="fileOverBase($event, 'image')">
                    <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasImageBaseDropZoneOver}">
                      <div class="columns medium-12 text-center">
                      <span class="pointer">
                        <img src="../../../images/tpiq-icons/upload-cloud.png"/>
                        <label for="resourceImagesUpload" class="button upload-section-content">Upload logo for resource thumbnail</label>
                      </span>
                        <input type="file" accept="image/*" id="resourceImagesUpload" (change)="fileDropOver($event, 'image')" value="null" class="show-for-sr" ng2FileSelect [uploader]="resourceImageUploader"/>
                      </div>
                    </div>
                  </section>
                </label>
              </div>
              <div class="mt-3" *ngIf="resourceLogoFiles.length > 0">
                <div class="d-flex flex-wrap">
                  <div class="d-flex uploaded-file-box mb-2 flex-column" *ngFor="let logo of resourceLogoFiles; let index = index;">
                    <ng-template [ngIf]="logo.name">
                      <div class="d-flex justify-content-between file-name-box w-100">
                        <div class="file-name">{{logo.name}}</div>
                        <div class="pointer" (click)="deleteDocumentFile(logo, index, 'resource image')">
                          <i class="icon ion-android-close"></i>
                        </div>
                      </div>
                      <div class="mt-2" style="padding: 0px;margin-left: 0px" *ngIf="logo.link">
                        <img class="image-zoom" [src]="logo.link"/>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <label>Files</label>
                <section class="upload-area create-post" ng2FileDrop [uploader]="resourceUploader" (onFileDrop)="fileDropOver($event, 'resource')" (fileOver)="fileOverBase($event, 'resource')">
                  <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasBaseDropZoneOver}">
                    <div class="columns medium-12 text-center">
                      <span class="pointer">
                        <img src="../../../images/tpiq-icons/upload-cloud.png"/>
                        <label for="resourceUpload" class="button upload-section-content">Upload File(s)</label>
                      </span>
                      <input type="file" id="resourceUpload" (change)="fileDropOver($event, 'resource')" value="null" class="show-for-sr" ng2FileSelect [uploader]="resourceUploader"/>
                    </div>
                  </div>
                </section>
              </div>
              <div class="mt-3" *ngIf="resource.files && resource.files.length > 0">
                <div class="d-flex flex-wrap">
                  <div class="uploaded-file-box d-flex justify-content-between mb-2"  *ngFor="let file of resource.files; let i=index;">
                    <div *ngIf="file.fileType === 'pdf'"><img src="../../../images/tpiq-icons/pdf-icon.png"/></div>
                    <div *ngIf="file.fileType === 'excel'"><img src="../../../images/tpiq-icons/excel-icon.png"/></div>
                    <div *ngIf="file.fileType === 'image'">
                      <i class="icon ion-image"></i>
                    </div>
                    <div *ngIf="file.fileType === 'video'">
                      <i class="icon ion-ios-videocam"></i>
                    </div>
                    <div class="file-name">{{file.name}}</div>
                    <div class="pointer" (click)="deleteDocumentFile(file, i, 'resource')">
                      <i class="icon ion-android-close"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <button class="button small float-right resource-button" (click)="createOrUpdateResource()">{{(resourceEditMode) ? 'Update' : 'Create'}}</button>
              <button class="button small float-right cancel-button resource-button" (click)="toggleCreateResource()">Cancel</button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

  </ng-template>




<div *ngIf="reveal['editPlan']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['editPlan']}">
  </div>
  <div class="reveal tax-strategy-reveal new-tpiq-reveal" style="padding: 0; border: none;" [ngClass]="{'tpiq-reveal': reveal['editPlan']}">
    <div class="reveal-header">
      <span class="float-left">{{(editMode) ? 'Edit Event' : 'Create Event'}}</span>
      <span class="float-right pointer" (click)="hideReveal('editPlan')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish new-input-fields d-flex flex-column flex-fill min-h-0 overflow-auto" style="padding: 15px;height: calc(100vh - 60px)">
      <div class="d-flex flex-column">
        <div>
          <label>Title*
            <input type="text" placeholder="Enter title here..." [(ngModel)]="plan.name"/>
          </label>
        </div>
        <div class="mb-3">
          <label>Description*
            <div class="padding-10" style="border:1px solid #cacaca;border-radius: 3px;" [froalaEditor]="editorOptions" [(froalaModel)]="plan.description"></div>
          </label>
        </div>
        <div class="d-flex mt-2 mb-2">
          <div class="d-flex flex-column" style="width: 30%;">
            <div>
              <label>Recurring</label>
            </div>
            <div>
              <input type="checkbox" [(ngModel)]="plan.recurring" [checked]="plan.recurring" />
            </div>
          </div>
          <div class="d-flex flex-column w-100">
            <div>
              <label>Frequency</label>
            </div>
            <div>
              <label>
                <ng-template [ngIf]="plan.recurring">
                  <app-tpiq-select-dropdown [setData]="frequencyTypes" [includeNone]="false" (onValueSelect)="setFrequency($event)"
                                         [setDefaultValue]="plan.frequency || 'Weekly'" [setSearchKey]="'name'" [setPlaceHolder]="'Frequency'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
                </ng-template>
                <ng-template [ngIf]="!plan.recurring">
                  <input type="text" placeholder="Frequency" disabled/>
                </ng-template>
              </label>
            </div>
          </div>
        </div>
        <ng-template [ngIf]="plan.recurring">
          <div class="d-flex gap-3 mt-3">
            <div class="w-100">
              <label>Start Date*
                <input class="float-left input-field" type="text" tpiq-custom-datepicker [hideYear]="true" [format]="'ddd, MMM DD YYYY'" [mindate]="minDate" [(ngModel)]="plan.startDate"
                       (valueChanged)="setPlanDate($event, 'start')"  placeholder="Date(ddd, MMM DD YYYY)"/>
              </label>
            </div>
            <div class="w-100">
              <label>End Date*
                <input class="float-left input-field" type="text" tpiq-custom-datepicker [hideYear]="true" [format]="'ddd, MMM DD YYYY'" [mindate]="minDate" [(ngModel)]="plan.endDate"
                       (valueChanged)="setPlanDate($event, 'end')"  placeholder="Date(ddd, MMM DD YYYY)"/>
              </label>
            </div>
          </div>
          <div class="d-flex gap-3">
            <div class="w-100">
              <label for="eventTime">Time*
                <input type="time" id="eventTime" name="eventTime" placeholder="Time" [(ngModel)]="plan.timeRange"/>
              </label>
            </div>
          </div>
        </ng-template>
        <div class="d-flex gap-3" *ngIf="!plan.recurring">
          <div class="w-100">
            <label>Date*
              <input class="float-left input-field" type="text" tpiq-custom-datepicker [hideYear]="true" [format]="'ddd, MMM DD YYYY'" [mindate]="minDate" [(ngModel)]="plan.date"
                     (valueChanged)="setPlanDate($event)"  placeholder="Date(ddd, MMM DD YYYY)"/>
            </label>
          </div>
          <div class="w-100">
            <label for="eventTime">Time*
              <input type="time" id="eventTime" name="eventTime" placeholder="Time" [(ngModel)]="plan.timeRange"/>
            </label>
          </div>
        </div>
        <div class="d-flex mt-2 mb-2">
          <div class="d-flex flex-column" style="width: 30%;">
            <div>
              <label>Pin This Event</label>
            </div>
            <div>
              <input type="checkbox" [(ngModel)]="plan.pinned" [checked]="plan.pinned" />
            </div>
          </div>
          <div class="d-flex flex-column w-100">
            <div>
              <label>Location
                <input type="text" placeholder="Location" [(ngModel)]="plan.location"/>
              </label>
            </div>
          </div>
        </div>
        <div>
          <label>Link
            <input type="text" placeholder="Link" [(ngModel)]="plan.link"/>
          </label>
        </div>
        <div>
          <label>Thumbnail
            <section class="upload-area create-post" ng2FileDrop [uploader]="uploader" (onFileDrop)="fileDropOver($event)" (fileOver)="fileOverBase($event)">
              <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasBaseDropZoneOver}">
                <div class="columns medium-12 text-center">
                <span class="pointer">
                  <img src="../../../images/tpiq-icons/upload-cloud.png"/>
                  <label for="eventThumbnailUpload" class="button upload-section-content">Upload logo for event thumbnail.</label>
                </span>
                  <input type="file" accept=".pdf,image/*" id="eventThumbnailUpload" (change)="fileDropOver($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader"/>
                </div>
              </div>
            </section>
          </label>
        </div>
        <div class="mt-3" *ngIf="logoFiles.length > 0">
          <div class="d-flex flex-wrap">
            <div class="d-flex uploaded-file-box mb-2 flex-column" *ngFor="let logo of logoFiles; let index = index;">
              <ng-template [ngIf]="logo.name">
                <div class="d-flex justify-content-between file-name-box">
                  <div class="file-name">{{logo.name}}</div>
                  <div class="pointer" (click)="deleteDocumentFile(logo, index)">
                    <i class="icon ion-android-close"></i>
                  </div>
                </div>
                <div class="mt-2" style="padding: 0px;margin-left: 0px" *ngIf="logo.link">
                  <img class="image-zoom" [src]="logo.link"/>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <button class="button small float-right" (click)="createOrEditPlan()">{{(editMode) ? 'Update' : 'Create'}}</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['showEvent']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['showEvent']}">
  </div>
  <div class="reveal tax-strategy-reveal new-tpiq-reveal" style="padding: 0; border: none;" [ngClass]="{'tpiq-reveal': reveal['showEvent']}">
    <div class="reveal-header">
      <span class="float-right pointer" (click)="hideReveal('showEvent')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish new-input-fields d-flex flex-column" style="padding: 15px;height: calc(100vh - 60px)">
      <div class="d-flex flex-column show-event flex-fill min-h-0 overflow-auto">
        <div class="d-flex flex-column growth-title-border">
          <div class="title ps-3">{{selectedEvent.name}}</div>
        </div>
        <div class="d-flex mt-3 event-date-sec">
          <div><img src="../../../../images/growth-plan/timer-dec.png"/></div>
          <div class="d-flex flex-column ps-3">
            <div class="event-date">{{selectedEvent.date}}</div>
            <div class="mt-1">Online, private for TaxPlanIQ paid users.</div>
            <div class="d-flex mt-3"><span class="text register-link float-right pointer" (click)="eventRegisterLink(selectedEvent)">Register Here <img class="growth-plan-icon ps-1" src="../../../../images/core-focus/external-link.png"/></span></div>
          </div>
        </div>
        <div class="mt-2" style="color: #475467">
          <app-tpiq-froala-view [data]="selectedEvent.description"></app-tpiq-froala-view>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['additionalResources']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['additionalResources']}">
  </div>
  <div class="reveal tax-strategy-reveal new-tpiq-reveal" style="padding: 0; border: none;" [ngClass]="{'tpiq-reveal': reveal['additionalResources']}">
    <div class="reveal-header">
      <span class="float-left">Additional Resources</span>
      <span class="float-right pointer" (click)="hideReveal('additionalResources')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish new-input-fields d-flex flex-column flex-fill min-h-0 overflow-auto" style="padding: 15px;height: calc(100vh - 60px)">
      <ng-template [ngIf]="!createOrEditResource">
        <div class="mb-3 padding-right-10" *ngIf="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'">
          <span class="pointer float-right upload-resource" (click)="uploadResource()"><i class="ion-plus-round pe-2"></i>Upload Resource</span>
        </div>
        <div class="d-flex flex-column padding-right-10">
          <ng-template [ngIf]="additionalResources && additionalResources.length > 0">
            <div class="d-flex flex-column additional-resources mb-3" *ngFor="let resource of additionalResources">
              <div class="resource-logo" [ngStyle]="resource.logoBg"></div>
              <div class="heading mt-3 d-flex">
                <div class="resource-name">{{resource.name}}</div>
                <ng-template [ngIf]="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'">
                  <div class="pointer" (click)="editResource(resource)"><i class="material-icons resource-edit">mode_edit</i></div>
                  <div class="pointer" (click)="deleteResource(resource)"><i class="material-icons resource-delete">delete</i></div>
                </ng-template>
              </div>
              <div class="text mt-2 resource-description" *ngIf="resource.description">
                <app-tpiq-froala-view [data]="resource.description"></app-tpiq-froala-view>
              </div>
              <div class="mt-2" *ngIf="resource.files && resource.files.length > 0">
                <div class="d-flex flex-wrap">
                  <div class="uploaded-file-box d-flex justify-content-between mb-2"  *ngFor="let file of resource.files; let i=index;">
                    <div *ngIf="file.fileType === 'pdf'"><img src="../../../images/tpiq-icons/pdf-icon.png"/></div>
                    <div *ngIf="file.fileType === 'excel'"><img src="../../../images/tpiq-icons/excel-icon.png"/></div>
                    <div *ngIf="file.fileType === 'image'">
                      <i class="icon ion-image" style="margin: 0"></i>
                    </div>
                    <div *ngIf="file.fileType === 'video'">
                      <i class="icon ion-ios-videocam"></i>
                    </div>
                    <div class="file-name resource-file-name">{{file.name}}</div>
                    <div class="pointer">
                      <img (click)="getFileData(file)" src="../../../images/tpiq-icons/download_icon.png"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template [ngIf]="additionalResources && additionalResources.length == 0">
            <div class="no-content-box">
              <div class="no-data-container d-flex align-items-center justify-content-center">
                No resources data available.
              </div>
            </div>
          </ng-template>
        </div>
      </ng-template>
      <ng-template [ngIf]="createOrEditResource">
        <div class="d-flex flex-column resource-edit-section">
          <div>
            <label>Name
              <input type="text" placeholder="Enter name here..." [(ngModel)]="resource.name"/>
            </label>
          </div>
          <div class="mb-3">
            <label>Description
              <div class="padding-10" style="border:1px solid #cacaca;border-radius: 3px;" [froalaEditor]="editorOptions" [(froalaModel)]="resource.description"></div>
            </label>
          </div>
          <div class="d-flex mt-2 mb-2">
          <div class="d-flex flex-column" style="width: 30%;">
            <div><label>Pin This Resource</label></div>
            <div>
              <input type="checkbox" [(ngModel)]="resource.pinned" [checked]="resource.pinned"/>
            </div>
          </div>
          </div>
          <div class="mt-2 mb-3">
            <label>
              Thumbnail
              <section class="upload-area create-post" ng2FileDrop [uploader]="resourceImageUploader" (onFileDrop)="fileDropOver($event, 'image')" (fileOver)="fileOverBase($event, 'image')">
                <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasImageBaseDropZoneOver}">
                  <div class="columns medium-12 text-center">
                  <span class="pointer">
                    <img src="../../../images/tpiq-icons/upload-cloud.png"/>
                    <label for="resourceImagesUpload" class="button upload-section-content">Upload logo for resource thumbnail</label>
                  </span>
                    <input type="file" accept="image/*" id="resourceImagesUpload" (change)="fileDropOver($event, 'image')" value="null" class="show-for-sr" ng2FileSelect [uploader]="resourceImageUploader"/>
                  </div>
                </div>
              </section>
            </label>
          </div>
          <div class="mt-3" *ngIf="resourceLogoFiles.length > 0">
            <div class="d-flex flex-wrap">
              <div class="d-flex uploaded-file-box mb-2 flex-column" *ngFor="let logo of resourceLogoFiles; let index = index;">
                <ng-template [ngIf]="logo.name">
                  <div class="d-flex justify-content-between file-name-box">
                    <div class="file-name">{{logo.name}}</div>
                    <div class="pointer" (click)="deleteDocumentFile(logo, index, 'resource image')">
                      <i class="icon ion-android-close"></i>
                    </div>
                  </div>
                  <div class="mt-2" style="padding: 0px;margin-left: 0px" *ngIf="logo.link">
                    <img class="image-zoom" [src]="logo.link"/>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="mt-2">
            <label>Files</label>
            <section class="upload-area create-post" ng2FileDrop [uploader]="resourceUploader" (onFileDrop)="fileDropOver($event, 'resource')" (fileOver)="fileOverBase($event, 'resource')">
              <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasBaseDropZoneOver}">
                <div class="columns medium-12 text-center">
                  <span class="pointer">
                    <img src="../../../images/tpiq-icons/upload-cloud.png"/>
                    <label for="resourceUpload" class="button upload-section-content">Upload File(s)</label>
                  </span>
                  <input type="file" id="resourceUpload" (change)="fileDropOver($event, 'resource')" value="null" class="show-for-sr" ng2FileSelect [uploader]="resourceUploader"/>
                </div>
              </div>
            </section>
          </div>
          <div class="mt-3" *ngIf="resource.files && resource.files.length > 0">
            <div class="d-flex flex-wrap">
              <div class="uploaded-file-box d-flex justify-content-between mb-2"  *ngFor="let file of resource.files; let i=index;">
                <div *ngIf="file.fileType === 'pdf'"><img src="../../../images/tpiq-icons/pdf-icon.png"/></div>
                <div *ngIf="file.fileType === 'excel'"><img src="../../../images/tpiq-icons/excel-icon.png"/></div>
                <div *ngIf="file.fileType === 'image'">
                  <i class="icon ion-image"></i>
                </div>
                <div *ngIf="file.fileType === 'video'">
                  <i class="icon ion-ios-videocam"></i>
                </div>
                <div class="file-name">{{file.name}}</div>
                <div class="pointer" (click)="deleteDocumentFile(file, i, 'resource')">
                  <i class="icon ion-android-close"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <button class="button small float-right resource-button" (click)="createOrUpdateResource()">{{(resourceEditMode) ? 'Update' : 'Create'}}</button>
          <button class="button small float-right cancel-button resource-button" (click)="toggleCreateResource()">Cancel</button>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<div *ngIf="reveal['oneOnOneEdit']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['oneOnOneEdit']}">
  </div>
  <div class="reveal tax-strategy-reveal new-tpiq-reveal" style="padding: 0; border: none;" [ngClass]="{'tpiq-reveal': reveal['oneOnOneEdit']}">
    <div class="reveal-header">
      <span class="float-left">Edit One On One Event</span>
      <span class="float-right pointer" (click)="hideReveal('oneOnOneEdit')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish d-flex flex-column flex-fill min-h-0 overflow-auto" style="padding: 15px;height: calc(100vh - 40px)">
      <app-one-on-one [event]="oneOnOneEvent" (onUpdateOfEvent)="closeOneOnOneEventEdit()"></app-one-on-one>
    </div>
  </div>
</div>
